export class NotificationVN {
    i: string;
    t: string;
    m: string;
    u?: string;
    d: Date;
    s: number;
    e: string;
    v: boolean;
    constructor(
        id: string,
        title: string,
        message: string,
        url: string,
        date: Date,
        visible: boolean = true
    ) {
        this.i = id;
        this.t = title;
        this.m = message;
        this.u = url;
        this.d = date;
        this.s = 0;
        this.e = '';
        this.v = visible;
    }
}
